import React from "react";
import "./Footer.css"; // You can create this CSS file
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} Quizzards.Ai™. All rights reserved.</p>
        <ul className="footer-links">
          <li><a href="/Home">Home</a></li>
          <li><a href="/blog">Blog</a></li>
          <li><a href="/signup">Create Account</a></li>
          <li><a href="/signin">Sign In</a></li>
          <Link to="/terms">Terms & Conditions</Link>
          <Link to="/privacy">Privacy</Link>
          
          
        </ul>
      </div>
    </footer>
  );
}
